module.exports = __webpack_public_path__ + "static/media/bindOutlook2.41ead114.png";